import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'hall-of-fame',
  path: () => `/hall-of-fame`,
}

export default ROUTE
